import React, {useEffect, useRef} from 'react';
import './styles.css';
import {colors} from '../../theme/colors';

const pointNum = 33;

const getRandom = (begin: number, end: number) => {
  return Math.floor((end - begin) * Math.random() + begin);
};

const getDarkerColor = (color: string, percent: number = -20): string => {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);

  R = Math.max(0, Math.floor(R * (1 + percent / 100)));
  G = Math.max(0, Math.floor(G * (1 + percent / 100)));
  B = Math.max(0, Math.floor(B * (1 + percent / 100)));

  return `#${((1 << 24) + (R << 16) + (G << 8) + B)
    .toString(16)
    .slice(1)
    .toUpperCase()}`;
};

const GenioAnimation = () => {
  const appRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let styleText = '';
    const head = document.head;
    const style = document.createElement('style');
    style.type = 'text/css';

    for (let i = 0; i < pointNum; i++) {
      styleText += `
        @keyframes pointY${i + 1} {
          0% { transform: translateY(${getRandom(-100, 300)}px); }
          25% { transform: translateY(${getRandom(-100, 300)}px); }
          50% { transform: translateY(${getRandom(-100, 300)}px); }
          75% { transform: translateY(${getRandom(-100, 300)}px); }
          100% { transform: translateY(${getRandom(-100, 300)}px); }
        }
        @keyframes pointX${i + 1} {
          0% { transform: translateX(${getRandom(-100, 300)}px); }
          25% { transform: translateX(${getRandom(-100, 300)}px); }
          50% { transform: translateX(${getRandom(-100, 300)}px); }
          75% { transform: translateX(${getRandom(-100, 300)}px); }
          100% { transform: translateX(${getRandom(-100, 300)}px); }
        }
      `;

      const pointOut = document.createElement('div');
      const pointIn = document.createElement('div');

      pointOut.className = `pointOut${i + 1}`;
      pointIn.className = `pointIn${i + 1}`;

      pointOut.style.animation = `pointX${i + 1} 14s linear infinite alternate`;
      pointIn.style.width = '0px';
      pointIn.style.height = '0px';
      pointIn.style.boxShadow = `0 0 60px 70px ${getDarkerColor(getRandom(0, 255) > 150 ? colors.secondary : colors.secondary, getRandom(-20, 20))} `;
      pointIn.style.transform = `translate(${getRandom(0, 255)}px, ${getRandom(0, 255)}px)`;
      pointIn.style.animation = `pointY${i + 1} 14s cubic-bezier(0.55, 0, 0.4, 1.01) infinite alternate`;

      pointOut.appendChild(pointIn);
      appRef.current?.appendChild(pointOut);
    }

    style.innerHTML = styleText;
    head.appendChild(style);

    return () => {
      // Cleanup: Remove style and elements when the component unmounts
      head.removeChild(style);
      if (appRef.current) appRef.current.innerHTML = '';
    };
  }, []);

  return (
    <div
      style={{opacity: 0.4, position: 'absolute', bottom: '10%', left: '20%'}}
      ref={appRef}>
      {/* Dynamic content will be added here */}
    </div>
  );
};

export default GenioAnimation;
